<div
  class="l-dialog__contents-custom"
  id="dialog_ana-biz-login"
  aria-labelledby="dialog_aria_recovery_leave"
  aria-modal="true"
  [@slideContent]="animationState"
  (@slideContent.start)="onAnimationStart($event)"
  (@slideContent.done)="onAnimationDone($event)"
>
  <div class="p-dialog" #dialogInfoDiv>
    <p
      #dialogInfo
      tabindex="0"
      (keydown)="onHandleKeydown($event, 0)"
      class="p-dialog__text"
      [innerHTML]="message | paramsTranslate : [] | popupIndicator | metaUrl | linkStyle"
    ></p>
    <div class="p-dialog-btn aws-p-dialog-btn-center">
      <button
        id="dialog_confirm-button_ana-biz-login"
        class="c-btn-{{ classType }} c-btn-{{ classType }}--s"
        aswThrottleClick
        (throttleClick$)="handleConfirmClick()"
        (keydown)="onHandleKeydown($event, 1)"
        #confirmBtn
      >
        <span class="c-btn-{{ classType }}__text" [innerHTML]="confirmBtnLabel | staticMsg"></span>
      </button>
    </div>
  </div>
</div>
